import { CenterHeaderComponentStackProvider } from '@perpay-web/fintech/hooks/useCenterHeaderContext';
import { FullHeaderComponentStackProvider } from '@perpay-web/fintech/hooks/useFullHeaderContext';
import { HeaderLeftNavComponentStackProvider } from '@perpay-web/fintech/hooks/useHeaderLeftNavContext';
import { HeaderRightNavComponentStackProvider } from '@perpay-web/fintech/hooks/useHeaderRightNavContext';
import { FullBottomNavComponentStackProvider } from '@perpay-web/hooks/useFullBottomNavContext';
import { TitleComponentStackProvider } from '@perpay-web/hooks/useTitleContext';
import { createCombinedProvider } from '@perpay-web/utils/componentUtils';

const ComponentStackProviders = createCombinedProvider(
    CenterHeaderComponentStackProvider,
    FullBottomNavComponentStackProvider,
    FullHeaderComponentStackProvider,
    HeaderRightNavComponentStackProvider,
    HeaderLeftNavComponentStackProvider,
    TitleComponentStackProvider,
);

export default ComponentStackProviders;
